import React from "react";

interface HeadingSecondaryProps {
  text: String;
  subText?: String;
  fontSize?: string;
}

const HeadingSecondary: React.FC<HeadingSecondaryProps> = ({ text, subText, fontSize }) => {
  return (
    <h1 className="heading-secondary">
      <span className="heading-secondary--main" style={{ fontSize: fontSize + "rem" }}>
        {text}
        <span>{subText}</span>
      </span>
    </h1>
  );
};

export default HeadingSecondary;
